const BaseComponent = require('base/base-component');
const Query = require('helper/query');
const ESClient = require('helper/es-client');
const Server = require('helper/server');

const searchlTpl = Handlebars.templates['templates/search-tpl'];
const listTpl = Handlebars.templates['templates/category-list-tpl'];
const detailTpl = Handlebars.templates['templates/category-detail-tpl'];
const catalogTableTpl = Handlebars.templates['templates/catalog-table-tpl'];
const { getCatalog, getProductList } = Server;

class CategoryPage extends BaseComponent {
  constructor (obj) {
    let params = {
      events: {
        'change .page-size': 'changPageSize',
        'click .dropdown-menu': 'changPageSize',
        'keydown .h-search #keyword': 'searchEvent',
        'click .h-search #search': 'searchEvent',
        'input .h-search #keyword': 'showClear',
        'click .h-search .icon-Shape': 'clearSearch',
        'click .catalog .iconfont': 'collapseCatalog',
        'click #advancedSearch': 'advancedSearch'
      }
    };
    if (obj && obj.events) {
      params.events = _.extend(params.events, obj.events);
    }
    super(params);
    // if (!obj) {
    //   obj = {
    //     events: {
    //       'change .page-size': 'changPageSize',
    //       'keydown .h-search #keyword': 'searchEvent',
    //       'click .h-search #search': 'searchEvent',
    //       'input .h-search #keyword': 'showClear',
    //       'click .h-search .icon-Shape': 'clearSearch',
    //       'click .catalog .iconfont': 'collapseCatalog',
    //       'click #advancedSearch': 'advancedSearch'
    //     }
    //   };
    // }
    // super(obj);
  }

  async init () {
    // console.log('init get session params', sessionStorage.getItem('params'));
    this.query = new Query();
    this.query.params.districtCode && typeof this.query.params.districtCode === 'string' && (this.query.params.districtCode = this.query.params.districtCode.split(','));
    // this.query.params = _.extend(JSON.parse(sessionStorage.getItem('params')), this.query.params);
    // console.log('this.query.params:', this.query.params);
    // sessionStorage.setItem('params', JSON.stringify(this.query.params));
    this.previewFlag = this.isFromPreview();
    this.pageNo = 1;
    this.pageSize = 15;
    this.client = new ESClient();
    this.$nav = this.$el.find('.list__nav');
    this.$navContent = this.$el.find('.list__nav-content');
    this.$content = this.$el.find('.list__content');
    this.$bread = this.$el.find('.list__bread');
    this.$searchPanel = this.$el.find('.list__search');
    const allTitle = this.$nav.find('.list__nav-title').text().trim();
    const share = this.$nav.find('#category-qr-show').text().trim();
    this.rootType = allTitle.replace(share,"").trim();
    const categoryTreeData = await this.treeData();
    this.initTree(categoryTreeData);
    this.fixMenu();
    this.initQRCode();
  }

  initQRCode () {
    const type = document.createElement('canvas').getContext ? 'canvas' : 'table';
    const siteId = $('input[name=siteId]').val();
    const appUrl = window.location.origin+"/app/category/index.html?id="+siteId;
    console.log('appUrl', appUrl);
    this.$el.find('.qr-show .qr-code').qrcode({
      render: `${type}`,
      width: 100,
      height: 100,
      text: appUrl,
    });
  }
  treeData () {
    return JSON.parse(this.$el.find('[name=tree-data]').text());
  }

  initTree (categoryTreeData) {
    let that = this;
    let mid = that.query.get('mid');
    let param = null;
    if (categoryTreeData.children && categoryTreeData.children instanceof Array) {
      // 若此分类没有子分类，理应可以用不用构建jstree，但是需用复用下面的一些列逻辑，所以选择隐藏jstree
      if (categoryTreeData.children.length === 0) {
        param = [categoryTreeData];
        $('.list-nav-content').hide();
      } else {
        param = categoryTreeData.children;
      }
    } else {
      param = categoryTreeData;
    }
    initTreeSelected(param, mid);
    /**
     * 菜单
     */
    that.$navContent
      .jstree({
        plugins: ['conditionalselect', 'wholerow'],
        conditionalselect: (...arg) => that.conditionalselect(...arg),
        core: {
          data: param,
          animation: 300
        }
      })
      .on('ready.jstree', (e, { instance }) => {
        // 渲染面包屑
        this.renderBreadcrumb(instance);
        // 初始化搜索框
        this.initSearchPanel();
        that.search();
      })
      .on('before_open.jstree', closeSiblingLeaf)
      .on('select_node.jstree', (...arg) => this.selectTreeNode(...arg));
  }

  renderList (resp) {
    if (!resp) {
      this.$content.find('.block__content').html(
        listTpl({
          _DATA_: { total: 0 },
          _pageSize_: this.pageSize || '15'
        })
      );
      this.initPagination(this.total || 0);
      return;
    }
    const { total } = resp.hits;
    this.total = total;
    const now = new Date().toDateString();
    // 遍历数据判断是否为新增
    resp.hits.hits.map(({ _source }) => {
      _source.isNew = new Date(_source.publishDate).toDateString() === now;
      return _source;
    });
    this.$content.find('.block__content').html(
      listTpl({
        _DATA_: resp.hits,
        _pageSize_: this.pageSize || '15'
      })
    );
    this.$el.find('.block__content .total').text(total);
    this.initPagination(this.total);
  }

  renderPreview (requestData) {
    Server.queryArticlePreview({
      data: requestData
    })
      .done((resp) => {
        this.$content.find('.block__content').html(detailTpl);
        this.initializeIframe(resp.content);
      });
  }

  renderDetail (requestData) {
    Server.queryArticleDetail({ data: requestData })
      .done((resp) => {
        if (resp) {
          // 防止过宽图片显示问题
          this.$content.find('.block__content').html(detailTpl());
          this.initializeIframe(resp);
        } else {
          this.$content.find('.block__content').html('<p class="noData">暂无数据</p>');
        }
      });
  }

  async renderCatalog (payload, query) {
    try {
      let { relevance, name, code, keyword } = query;
      let { data: catalogList = [] } = await getCatalog({ data: payload });
      const list = [];
      if (catalogList !== null && catalogList.length > 0) {
        let { code: { success = false }, data } = await getProductList({ data: { gpCatalogId: catalogList[0].gpCatalogId } });
        // 根据nodeId匹配关联商品类目字段
        data = data ? data : []; // eslint-disable-line
        data.forEach(({ prdList = [], nodeId }) => {
          if (success) {
            const arr = [];
            prdList.forEach(({ name: n }) => { n && arr.push(n); });
            let prdListName = arr.join('、');
            prdListName = prdListName.length > 10 ? prdListName.slice(0, 10) + '...' : prdListName;
            const a = catalogList.find(ele => ele.nodeId == nodeId);
            a.relevance = prdListName;
          }
        });
        // 搜索条件过滤，采购目录名称、代码、类目高级搜索由前端过滤
        keyword && (name = keyword);
        for (let i = 0, len = catalogList.length; i < len; i++) {
          const item = catalogList[i];
          // 过滤掉禁用的目录和其子目录
          if (item.isDisable) {
            while (catalogList[i + 1] && (catalogList[i + 1].depth > item.depth)) {
              i++;
            }
            continue;
          }
          // 过滤采购目录名称
          if (name && !item.name.includes(name)) {
            continue;
          }
          // 过滤类目
          if (relevance && !item.relevance.includes(relevance)) {
            continue;
          }
          // 过滤采购目录代码
          if (code && !item.code.includes(code)) {
            continue;
          }
          const { remark = '' } = item;
          const nextItem = catalogList[i + 1];
          if (remark && remark.length > 10) {
            item.remark = remark.substr(0, 10) + '...';
          }
          nextItem && nextItem.depth > item.depth ? item.isLeaf = false : item.isLeaf = true;
          list.push(item);
        }
      }
      this.$content.find('.block__content').html(catalogTableTpl({ _DATA_: list }));
    } catch (err) {
      console.log(err);
    }
  }

  renderBreadcrumb (instance) {
    const { text, parents: list } = this.selectedTreeNode;
    let arr = [text];
    for (let i = 0, len = list.length - 1; i < len; i++) {
      arr.unshift(instance.get_node(list[i]).original.text);
    }
    arr.unshift(this.rootType);
    const s = arr.join(' > ');

    this.$bread.find('#nav').text(s);
    if ($('#blockTitleIcon').val()) {
      this.$content.find('.block__title').html(`<i class="icon iconfont ${$('#blockTitleIcon').val()}" style="font-size:14px;margin-right:9px;"></i><span>${text}</span>`);
    } else {
      this.$content.find('.block__title').text(text);
    }
  }

  get selectedTreeNode () {
    let tree = this.$navContent.jstree(true);
    const selected = _.clone(tree.get_node(tree.get_selected()));
    return $.extend(selected, selected.original);
  }

  clearSearch (e) {
    let $searchInp = this.$searchPanel.find('#keyword');
    $searchInp.val('');
    $(e.target).hide();
    this.pageNo = 1;
    this.query = new Query();
    this.search();
  }

  showClear (e) {
    const $ele = $(e.currentTarget);
    if ($ele.val().length > 0) {
      this.$el.find('.h-search .icon-Shape').show();
    } else {
      this.$el.find('.h-search .icon-Shape').hide();
    }
  }

  /**
   * 采购目录展开收起
   * @param {*} e
   */
  collapseCatalog (e) {
    const $target = $(e.currentTarget);
    const $tr = $target.closest('tr');
    const depth = $tr.data('depth');
    const $leaf = $tr.nextUntil(`[data-depth=${depth}]`);
    if ($target.hasClass('icon-xiangxiazhedie')) {
      $target.removeClass('icon-xiangxiazhedie').addClass('icon-xiangshangzhedie');
      $leaf.hide();
    } else {
      $target.removeClass('icon-xiangshangzhedie').addClass('icon-xiangxiazhedie');
      $leaf.show();
    }
  }

  changPageSize (e) {
    this.pageSize = $(e.target).data('num') || $(e.target).val();
    this.pageNo = 1;
    this.search();
  }

  selectTreeNode (event, data) {
    const url = data.instance.get_node(data.instance.get_selected()[0]).original.url;
    // location.href = url;
    location.href = `${url}${window.location.search}`;
  }

  isFromPreview () {
    const isFromPreview = this.query.get('PID');
    if (isFromPreview) {
      // 后台预览时禁用点击
      document.body.addEventListener('click', (e) => {
        e.preventDefault();
        return false;
      }, true);
    }
    return isFromPreview;
  }

  searchEvent (e) {
    if (e.type === 'keydown' && e.keyCode == 13) {
      this.query.init();
      this.query.set('keyword', $(e.currentTarget).val().trim());
    } else if (e.type === 'click') {
      this.query.init();
      this.query.set('keyword', $(e.currentTarget).siblings('#keyword').val());
    } else if (e.type === 'keydown') {
      return;
    }
    this.pageNo = 1;
    this.$content.find('.block__title').text('搜索结果');
    this.search();
  }

  /**
   * @param showContent true:显示文章,false:显示列表
   */
  initSearchPanel () {
    const { showContent = false } = this.selectedTreeNode;
    if (showContent) {
      this.$searchPanel.html('');
    } else {
      this.$searchPanel.html(searchlTpl);
    }
  }

  initializeIframe (articleDetail = '') {
    const $iframe = $('#article-content');
    $iframe.on('load', () => setTimeout(resizeIframe()));
    const buildTemplate = (content = '') => `
        <!DOCTYPE html>
        <html xmlns='http://www.w3.org/1999/xhtml' class='view'>
        <head>
          <style type='text/css'>.view{padding:0;word-wrap:break-word;cursor:text;height:90%;}body{margin:8px;font-family:sans-serif;font-size:16px;}p{margin:5px 0;}
          </style>
          <style>
            img {
              max-width: 100%;
            }
          </style>
          <style id="table">.selectTdClass{background-color:#edf5fa !important}table.noBorderTable td,table.noBorderTable th,table.noBorderTable caption{border:1px dashed #ddd !important}table{margin-bottom:10px;border-collapse:collapse;display:table;}td,th{padding: 5px 10px;border: 1px solid #DDD;}caption{border:1px dashed #DDD;border-bottom:0;padding:3px;text-align:center;}th{border-top:1px solid #BBB;background-color:#F7F7F7;}table tr.firstRow th{border-top-width:2px;}.ue-table-interlace-color-single{ background-color: #fcfcfc; } .ue-table-interlace-color-double{ background-color: #f7faff; }td p{margin:0;padding:0;}</style>
          <style id="list">ol,ul{margin:0;pading:0;width:95%}li{clear:both;}.list-paddingleft-1{padding-left:0}.list-paddingleft-2{padding-left:30px}.list-paddingleft-3{padding-left:60px}</style>
          <style id="pre">pre{margin:.5em 0;padding:.4em .6em;border-radius:8px;background:#f8f8f8;}</style>
          <style>.fjxx{box-sizing: border-box;}</style>
          <style>.template-law{font-size:14px;}.law-info{width:100%;background:#f9f9f9;border:1px solid #eee;text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-info > tbody > tr > td{padding:5px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100px;}.law-info > tbody > tr > td p{max-width:190px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}.law-info .text-right{text-align:right;}.law-info .info_title{height:32px;font-size:16px;color:#f00;font-weight:bold;text-align:center;}.law-info td,th{border:0;}.law-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-title h1{width:100%;text-align:center;font-size:40px;color:#f00;text-decoration:none;font-weight:bold;margin-bottom:60px;margin:0;padding:120px 0 60px 0;}.law-title h2{border-bottom:#f00 solid 3px;line-height:50px;font-size:17px;color:#000;text-decoration:none;font-weight:normal;height:50px;width:100%;text-align:center;padding:0;margin:0 0 40px 0;}.law-title p{font-size: 20px;padding-bottom:15px;}</style>
        </head>
        <body class='view'>${content}</body>
        </html>`;
    const doc = $iframe[0].contentDocument;
    const content = articleDetail.replace(/contenteditable="true"/g, '')
      .replace(/<section/g, '<div')
      .replace(/<\/section>/g, '</div>');
    if (typeof articleDetail === 'string') {
      doc.open();
      doc.write(buildTemplate(content));
      doc.close();
    } else {
      doc.open();
      doc.write('<div id="iframe-root"></div>');
      doc.close();
    }
  }

  /**
   * 初始化分页
   * @param count 总条数
   */
  initPagination (count) {
    let that = this;
    let sources = (function () {
      let result = [];
      count > 9900 && (count = 9900); // es不支持index大于10000的分页查询
      for (let i = 0; i < count; i++) {
        result.push(i);
      }
      return result;
    })();
    that.pageSize = that.$el.find('.pagination-container .page-size').val() || that.pageSize || 15;
    /* eslint-disable */
    let options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: that.pageSize,
      pageNumber: that.pageNo,
      prevText: '<',
      nextText: '>',
      showGoInput: true,
      showGoButton: true,
      beforeGoButtonOnClick: (event, pageNumber) => {
        let lastPageNo = $('.paginationjs-last').data('num');
        if (!lastPageNo) {
          lastPageNo = $('.J-paginationjs-page:last').data('num');
        }
        if (pageNumber > lastPageNo) {
          alert('跳转页数不得大于最大页数');
          return;
        }
        if (pageNumber >= 1) {
          that.pageNo = pageNumber;
          that.search();
        }
      },
      beforePageOnClick: (event, pageNumber) => {
        that.pageNo = pageNumber;
        that.search();
      },
      beforeGoInputOnEnter: (event, pageNumber) => {
        let lastPageNo = $('.paginationjs-last').data('num');
        if (!lastPageNo) {
          lastPageNo = $('.J-paginationjs-page:last').data('num');
        }
        if (!/^\d+$/.test(pageNumber) || pageNumber > lastPageNo || pageNumber < 1) {
          alert('跳转页数不合法');
          return;
        }
        that.pageNo = pageNumber;
        that.search();
      },
      beforePreviousOnClick: () => {
        that.pageNo--;
        that.search();
      },
      beforeNextOnClick: () => {
        that.pageNo++;
        that.search();
      }
    };
    /* eslint-enable */
    that.$el.find('.pagination-container .pagination-list')[0] && that.$el.find('.pagination-container .pagination-list').pagination(options);
  }

  fixMenu () {
    const { top } = this.$content.offset();
    $(window).on('scroll', () => {
      let h = this.$content.height();
      let st = $(document).scrollTop();
      if (h > 800) {
        if (st > top && st < h - 260) {
          this.$nav.css({
            position: 'fixed',
            top: '0'
          });
        } else if (st >= h - 260) {
          this.$nav.css({
            position: 'absolute',
            top: h - 700
          });
        } else {
          this.$nav.css({
            position: 'absolute',
            top: '0'
          });
        }
      } else {
        this.$nav.css({
          position: 'absolute',
          top: '0'
        });
      }
    });
  }

  advancedSearch () {}

  // 菜单选中条件
  conditionalselect () {
    if (this.previewFlag) {
      return false;
    }
    return true;
  }
}

module.exports = CategoryPage;


/**
 * 初始化tree默认选中
 * @param treeData tree的data对象
 * @param mid 要选中treenode的id
 */
function initTreeSelected (treeData, mid) {
  const select = (data) => {
    for (let i = 0, len = data.length; i < len; i++) {
      const item = data[i];
      let { selected, children } = item;
      if (selected) {
        item.state = { selected: true };
        return true;
      }
      if (children) {
        if (select(children)) {
          return true;
        }
      }
    }
  };
  const selectWithid = (data) => {
    for (let i = 0, len = data.length; i < len; i++) {
      const item = data[i];
      if (item.id == mid) {
        item.state = { selected: true };
        break;
      }
      if (item.children) {
        selectWithid(item.children);
      }
    }
  };
  const selectDefault = (data) => {
    if (data instanceof Array) {
      if (data[0].children && data[0].children.length > 0) {
        selectDefault(data[0].children);
      } else {
        data[0].state = { selected: true };
      }
    } else {
      data.state = { selected: true };
    }
  };
  if (mid) {
    selectWithid(treeData);
  } else {
    !select(treeData) && selectDefault(treeData);
  }
}

function resizeIframe () {
  const $iframe = $('#article-content');
  const iframeBodyHeight = $iframe[0].contentDocument.body.scrollHeight;
  $iframe.height((iframeBodyHeight + 20) + 'px');
}
/**
 * jstree二级分类闭合同级节点
 * @param {*} event
 * @param {*} data
 */
function closeSiblingLeaf (event, data) {
  let arr = null;
  if (data.node.parents.length == 1) {
    arr = data.instance.get_node(data.node.parent).children.slice();
    arr.splice(arr.indexOf(data.node.id), 1);
    for (let i = 0, len = arr.length; i < len; i++) {
      let itemNode = data.instance.get_node(arr[i]);
      if (
        data.instance.is_parent(itemNode) &&
        data.instance.is_open(itemNode)
      ) {
        data.instance.close_node(itemNode, 200);
      }
    }
  }
}
